import {Dispatch, SetStateAction} from "react";

export type State<T> = [T, Dispatch<SetStateAction<T>>]

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const getDefaultStatefulContext = <T>(defaultValue: T): [T, Dispatch<SetStateAction<T>>] => [defaultValue, (_: unknown) => {}]